import React from 'react';
import './HeroSection.scss';

const HeroSection = ({ onOpenWebhookDocs }) => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <div className="hero-text">
          <h1>Jely External API</h1>
          <p className="hero-subtitle">
            Powerful and easy-to-use APIs for seamless integration with Jely's 
            messaging and notification platform.
          </p>
          <div className="hero-cta">
            <button className="cta-button" onClick={onOpenWebhookDocs}>Webhook Docs</button>
          </div>
          <div className="hero-features">
            <div className="feature-item">
              <div className="feature-icon">🚀</div>
              <span>Fast & Reliable</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🔒</div>
              <span>Secure</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">📱</div>
              <span>WhatsApp Integration</span>
            </div>
            <div className="feature-item">
              <div className="feature-icon">🔧</div>
              <span>Developer Friendly</span>
            </div>
          </div>
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">99.9%</span>
              <span className="stat-label">Uptime</span>
            </div>
            <div className="stat">
              <span className="stat-number">10</span>
              <span className="stat-label">Endpoints</span>
            </div>
            <div className="stat">
              <span className="stat-number">24/7</span>
              <span className="stat-label">Support</span>
            </div>
          </div>
        </div>
        <div className="hero-visual">
          <div className="api-illustration">
            <div className="code-block">
              <div className="code-header">
                <div className="dots">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
                <span className="filename">example.js</span>
              </div>
              <div className="code-content">
                <div className="code-line">
                  <span className="keyword">const</span> <span className="variable">response</span> = <span className="keyword">await</span> <span className="function">fetch</span>(<span className="string">'api/send-notification'</span>, {"{"}
                </div>
                <div className="code-line indent">
                  <span className="property">method</span>: <span className="string">'POST'</span>,
                </div>
                <div className="code-line indent">
                  <span className="property">headers</span>: {"{"}
                </div>
                <div className="code-line indent-2">
                  <span className="string">'x-api-key'</span>: <span className="variable">YOUR_API_KEY</span>
                </div>
                <div className="code-line indent">
                  {"}"},
                </div>
                <div className="code-line indent">
                  <span className="property">body</span>: <span className="function">JSON.stringify</span>(<span className="variable">data</span>)
                </div>
                <div className="code-line">
                  {"}"});
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
